import React from 'react';
import { Button } from '@odmonorepo/core-components';
import { Card, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

interface DefaultErrorPageProps {
  title?: React.ReactNode;
  message?: React.ReactNode;
  contactName?: string;
  contactDescription?: any;
  link?: string;
  CTA?: string;
  hasHeader?: boolean;
  customerServiceCard?: boolean;
  redirectTo?: React.ReactNode;
  cardTitle?: React.ReactNode;
  subTitle?: React.ReactNode;
}

const DefaultTitle = () => <FormattedMessage id="customError.generic.title" defaultMessage="Something went wrong." />
const DefaultMessage = () => <FormattedMessage id="customError.generic.message"
                                values={{ break: <br />, reload: <a href="#" onClick={(e) => { e.preventDefault(); window.location.reload(); }}>Reload this page</a> }} defaultMessage="{reload} to try again. If the problem persists, please call your loan advisor." />

export const DefaultErrorPage = (
  {
    title = <DefaultTitle />,
    message = <DefaultMessage />,
    customerServiceCard = true,
    contactName = 'OnDeck Customer Service',
    contactDescription = (
      <>
        Monday - Friday<br />9:00 a.m. - 7:30 p.m. ET
      </>
    ),
    link = 'tel:+18885563483',
    CTA = 'Call (888) 556-3483',
    hasHeader = true,
    redirectTo = null,
    cardTitle = null,
    subTitle = null,
  }: DefaultErrorPageProps) => {
  return (
    <div className="text-center" style={{ paddingTop: hasHeader ? 0 : 32 }}>
      <div className="h3 mb-5 mx-3">{title}</div>
      <Stack gap={5} className="pt-3 m-0 mx-auto" style={{ maxWidth: 600, width: '100%' }}>
        <Card className="pt-4 pb-4 px-4" >
          <div className="mx-5 px-sm-5 py-5 text-start">
            {cardTitle && <div className="h4">{cardTitle}</div>}
            {subTitle && <div className="h4 mb-3">{subTitle}</div>}
            {message}
            {customerServiceCard && <Card className="py-5 mt-5 px-3 text-center bg-light-gray shadow-none">
              <div className="h4">{contactName}</div>
              <div>{contactDescription}</div>
              <Button type="button" className="mt-4 mb-1 mx-auto" href={link}>{CTA}</Button>
            </Card>}
          </div>
          { redirectTo }
        </Card>
      </Stack>
    </div>
  );
};


export default DefaultErrorPage;
